var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowLoading)?_c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"loading-box"},[_c('a-spin'),_c('span',{staticClass:"loading-txt"},[_vm._v(_vm._s(_vm.content || '请稍候'))])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }